var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJewelry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1431 7.42941L12.0003 19.4294L0.857422 7.42941L6.00028 0.572266H18.0003L23.1431 7.42941ZM0.857422 7.42941H23.1431H0.857422Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1431 7.42941L12.0003 19.4294L0.857422 7.42941M23.1431 7.42941L18.0003 0.572266H6.00028L0.857422 7.42941M23.1431 7.42941H0.857422",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJewelry);
export default __webpack_public_path__ + "static/media/icon-jewelry.27ddc3d4318a8d761f61a771122d6700.svg";
export { ForwardRef as ReactComponent };